import _ from 'underscore';

import {naturalSort} from 'common/utils';


const _matches = (search, str) => str.toLowerCase().indexOf(search.trim().toLowerCase()) !== -1;

/* Check the address's name & address against the search input. */
const _addressMatch = (search, address) => _.any([
  _matches(search, address.name),
  _matches(search, address.address),
]);

/* Use natural sort with the address's name. */
const _addressSort = (a, b) => naturalSort.compare(a.name, b.name);

/* Match the output used for PlacesAutocomplete. */
const _addressFormat = (address) => ({
  address: address.address,
  name: address.name,
  source: address.type,
  position: () => new Promise(resolve => resolve(address.position)),
});

/* Filter addresses according to input from the user for use with PlacesAutocomplete. */
export const addressSource = (addresses) =>
  ({input}) =>
    addresses.filter(_.partial(_addressMatch, input)).sort(_addressSort).map(_addressFormat);



// WEBPACK FOOTER //
// ./src/common/utils/addresses.js